// this route in custom tabs for base route of pricing list
export const PRICING_LIST_EXACT_ROUTE =
  '/staff/finance/dashboard/pricing-list/';

export enum EyeInvolvement {
  OneEye = 1,
  BothEyes = 2,
}

interface ITabItem {
  label: string;
  path: string;
}

export const tabItems: ITabItem[] = [
  {label: 'Consultation', path: 'consultation'},
  {label: 'Diagnostic/Other Fees', path: 'diagnostic'},
  {label: 'Refractive/Cataract', path: 'refractive'},
  {label: 'Retinal', path: 'retinal'},
  {label: 'Oculoplastics and Lacrimal', path: 'oculoplastics'},
  {label: 'Corneal and Conjunctival', path: 'corneal'},
  {label: 'Glaucoma', path: 'glaucoma'},
  {label: 'Add-ons', path: 'addons'},
];
